import { darkenColor } from 'src/util/color'

const ENAMEL_COLORS = [
  { label: 'ホワイト', value: 'white', color: '#fff' },
  { label: 'ブラック', value: 'black', color: '#0a0a0a' },
  { label: 'シルバー', value: 'silver', color: 'silver' },
  { label: 'ゴールド', value: 'gold', color: '#debd00' },
  { label: 'レッド', value: 'red', color: '#c70000' },
  { label: 'Rブルー', value: 'royalBlue', color: '#002bff' },
  { label: 'ネイビー', value: 'navy', color: '#363C53' },
  { label: 'オレンジ', value: 'orange', color: '#fa6e02' },
  { label: 'グリーン', value: 'green', color: '#18493A' },
  { label: 'イエロー', value: 'yellow', color: '#F6E020' },
  { label: 'パープル', value: 'purple', color: '#39286A' },
  { label: 'エンジ', value: 'burgundy', color: '#8A2F33' },
  { label: 'ピンク', value: 'pink', color: '#ff1493' },
  { label: 'Fブルー', value: 'fBlue', color: '#00a5c9' }
]

const ENAMEL_MESH_COLORS = [
  { label: 'ホワイト', value: 'white', color: '#fff' },
  { label: 'ブラック', value: 'black', color: '#0a0a0a' },
  { label: 'ゴールド', value: 'gold', color: '#debd00' },
  { label: 'レッド', value: 'red', color: '#c70000' },
  { label: 'Rブルー', value: 'royalBlue', color: '#002bff' },
  { label: 'ネイビー', value: 'navy', color: '#363C53' },
  { label: 'オレンジ', value: 'orange', color: '#fa6e02' },
  { label: 'グリーン', value: 'green', color: '#18493A' },
  { label: 'イエロー', value: 'yellow', color: '#F6E020' },
  { label: 'エンジ', value: 'burgundy', color: '#8A2F33' },
  { label: 'ピンク', value: 'pink', color: '#ff1493' }
]

const SMOOTH_COLORS = [
  { label: 'ホワイト', value: 'white', color: '#dedede' },
  { label: 'ブラック', value: 'black', color: '#121212' },
  { label: 'レッド', value: 'red', color: '#a30000' },
  { label: 'Rブルー', value: 'royalBlue', color: '#0022c7' },
  { label: 'ネイビー', value: 'navy', color: '#141a30' }
]

const NUBUCK_COLORS = [
  { label: 'ブラック', value: 'black', color: '#0a0a0a' },
  { label: 'レッド', value: 'red', color: '#c70000' },
  { label: 'Rブルー', value: 'royalBlue', color: '#002bff' },
  { label: 'ネイビー', value: 'navy', color: '#363C53' },
  { label: 'オレンジ', value: 'orange', color: '#fa6e02' },
  { label: 'グリーン', value: 'green', color: '#18493A' },
  { label: 'イエロー', value: 'yellow', color: '#F6E020' },
  { label: 'パープル', value: 'purple', color: '#800096' },
  { label: 'エンジ', value: 'burgundy', color: '#8A2F33' },
  { label: 'ピンク', value: 'pink', color: '#ff1493' },
  { label: 'Lピンク', value: 'lPink', color: '#AB4F89' },
  { label: 'グレー', value: 'gray', color: 'gray' },
  { label: 'サックス', value: 'sucks', color: '#5189A9' },
  { label: 'ブラウン', value: 'brown', color: '#8B5824' },
  { label: 'ライトコルク', value: 'lightCork', color: '#B79462' },
  { label: 'エメラルドグリーン', value: 'emeraldGreen', color: '#44AE75' },
  { label: 'クリーム', value: 'cream', color: '#F4F5BC' }
]

export const MESH_COLORS = [
  { label: 'ブラック', value: 'black', color: '#0a0a0a' },
  { label: 'ホワイト', value: 'white', color: '#fff' },
  { label: 'レッド', value: 'red', color: '#c70000' },
  { label: 'Rブルー', value: 'royalBlue', color: '#002bff' },
  { label: 'ネイビー', value: 'navy', color: '#363C53' },
  { label: 'オレンジ', value: 'orange', color: '#fa6e02' },
  { label: 'グリーン', value: 'green', color: '#18493A' },
  { label: 'イエロー', value: 'yellow', color: '#F6E020' },
  { label: 'エンジ', value: 'burgundy', color: '#8A2F33' },
  { label: 'サックス', value: 'sucks', color: '#5189A9' },
  { label: 'ピンク', value: 'pink', color: '#ff1493' },
  { label: 'グレー', value: 'gray', color: 'gray' }
]

export const TOE_GUARD_COLORS = [
  // { label: 'ホワイト', value: 'white', color: '#DFE0C8' },
  // { label: 'ブラック', value: 'black', color: '#121212' },
  // { label: 'レッド', value: 'red', color: '#c70000' },
  // { label: 'Rブルー', value: 'royalBlue', color: '#002bff' },
  // { label: 'ネイビー', value: 'navy', color: '#363C53' }
  { label: 'ホワイト', value: 'white', color: '#dedede' },
  { label: 'ブラック', value: 'black', color: '#121212' },
  { label: 'レッド', value: 'red', color: '#a30000' },
  { label: 'Rブルー', value: 'royalBlue', color: '#0022c7' },
  { label: 'ネイビー', value: 'navy', color: '#141a30' }
]

export const COLORS = {
  enamel: ENAMEL_COLORS,
  enamelMesh: ENAMEL_MESH_COLORS,
  smooth: SMOOTH_COLORS,
  nubuck: NUBUCK_COLORS,
  nubuckMesh: NUBUCK_COLORS,
  smoothMesh: SMOOTH_COLORS,
  RobenicaMesh: [],
  RobenicaSmooth: []
}

export const LINES = [
  { label: 'ホワイト', value: 'white', color: '#fff' },
  { label: 'ブラック', value: 'black', color: '#0a0a0a' },
  { label: 'シルバー', value: 'silver', color: 'silver' },
  { label: 'ゴールド', value: 'gold', color: '#debd00' },
  { label: 'レッド', value: 'red', color: '#c70000' },
  { label: 'Rブルー', value: 'royalBlue', color: '#002bff' },
  { label: 'ネイビー', value: 'navy', color: '#363C53' },
  { label: 'オレンジ', value: 'orange', color: '#fa6e02' },
  { label: 'グリーン', value: 'green', color: '#18493A' },
  { label: 'イエロー', value: 'yellow', color: '#F6E020' },
  { label: 'パープル', value: 'purple', color: '#800096' },
  { label: 'エンジ', value: 'burgundy', color: '#8A2F33' },
  { label: 'ピンク', value: 'pink', color: '#ff1493' },
  { label: 'Fブルー', value: 'fBlue', color: '#00a5c9' }
]

const RESET = { label: 'リセット', value: 'unselected', color: 'white' }
export const MAGIC_BELT_VAMP_STRAPS = {
  enamel: [...ENAMEL_COLORS, RESET],
  smooth: [...SMOOTH_COLORS, RESET],
  nubuck: [...NUBUCK_COLORS, RESET],
  unselected: [RESET]
}
export const LACE_VAMP_STRAPS = [
  { label: 'ブラック', value: 'black', color: '#0a0a0a' },
  { label: 'ホワイト', value: 'white', color: '#fff' },
  { label: 'ネイビー', value: 'navy', color: '#363C53' },
  { label: 'Rブルー', value: 'royalBlue', color: '#002bff' },
  { label: 'レッド', value: 'red', color: '#c70000' }
]

export const VAMP_STRAPS = [...LACE_VAMP_STRAPS, ...ENAMEL_COLORS, ...SMOOTH_COLORS, ...NUBUCK_COLORS, RESET]

export const STITCHES = [
  { label: 'ブラック', value: 'black', color: darkenColor('#0a0a0a', 0.2) },
  { label: 'ホワイト', value: 'white', color: '#ddd' },
  { label: 'ネイビー', value: 'navy', color: darkenColor('#363C53', 0.2) },
  { label: 'Rブルー', value: 'royalBlue', color: darkenColor('#002bff', 0.2) },
  { label: 'スカイブルー', value: 'skyBlue', color: darkenColor('#4EB5DC', 0.2) },
  { label: 'レッド', value: 'red', color: darkenColor('#c70000', 0.2) },
  { label: 'シルバー', value: 'silver', color: 'silver' },
  { label: 'ゴールド', value: 'gold', color: darkenColor('#debd00', 0.2) },
  { label: 'オレンジ', value: 'orange', color: darkenColor('#fa6e02', 0.2) },
  { label: 'グリーン', value: 'green', color: darkenColor('#009c09', 0.2) },
  { label: 'イエロー', value: 'yellow', color: darkenColor('#F6E020', 0.2) },
  { label: 'ピンク', value: 'pink', color: darkenColor('#ff1493', 0.2) }
]

export const TONGUE_LININGS = [
  { label: 'ホワイト', value: 'white', color: 'white' },
  { label: 'ブラック', value: 'black', color: 'black' },
  { label: 'シルバー', value: 'silver', color: 'silver' },
  { label: 'ゴールド', value: 'gold', color: '#debd00' },
  { label: 'レッド', value: 'red', color: 'red' },
  { label: 'Rブルー', value: 'royalBlue', color: 'blue' },
  { label: 'ネイビー', value: 'navy', color: 'navy' },
  { label: 'オレンジ', value: 'orange', color: 'orange' },
  { label: 'グリーン', value: 'green', color: '#009c09' },
  { label: 'イエロー', value: 'yellow', color: '#F6E020' },
  { label: 'パープル', value: 'purple', color: '#39286A' },
  { label: 'サックス', value: 'sucks', color: '#5189A9' },
  { label: 'ピンク', value: 'pink', color: '#ff1493' },
  { label: 'グレー', value: 'gray', color: 'gray' }
]
export const MAGIC_BELT_BASES = [
  { label: 'ホワイト', value: 'white', color: '#eee' },
  { label: 'ブラック', value: 'black', color: '#141414' }
]

export const ATOMS_LABELS = [{ label: 'ブラックxゴールド', value: 'blackGold', imageUrl: '/atoms/labels/c.jpg' }]

export const MAGIC_BELT_MATERIALS = [
  { label: 'エナメル', value: 'enamel' },
  { label: 'トリベラスムース', value: 'smooth' },
  { label: 'ヌバック', value: 'nubuck' }
]
